import { CacheService } from 'ng2-cache-service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { CookieService } from 'app/services/cookie.service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';
import { GlobalValuesService } from 'app/services/global-values.service';

/**
 * Service for application logout.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
@Injectable()
export class LogoutService {
    constructor(private requestService: ObservableRequestService,
      private cookieService: CookieService,
      private cacheService: CacheService,
      private globalValuesService: GlobalValuesService) { }

    // Method to process logout.
    processLogout(): Observable<any> {
        this.globalValuesService.setIsLoggedIn(false);
        let sessionId = this.cookieService.get(ConstantsService.COOKIE_SESSION_ID);

        if (!sessionId) {
            sessionId = '0';
        }
        return this.requestService.getRequest(ConstantsService.APP_LOGOUT + sessionId);
    }

    // Deletes credentials if logout request is sent.
    deleteCredentials(): void {
        this.cacheService.removeAll();

        // Force clearing of local storage to fix a FF bug
        sessionStorage.clear();

        // Remove All is clearing the cookies.
        this.cookieService.removeAll();
        // @todo Right now, we have hard-coded the cookie path 'demo'. We might
        // need to change it based on server path on which the application will
        // get deployed.
        this.deleteServerGeneratedCookies('JSESSIONID', '', -1);
        this.deleteServerGeneratedCookies('JSESSIONID', '', -1, '/demo/');
        this.deleteServerGeneratedCookies('JSESSIONID', '', -1, '/angular/');
        this.deleteServerGeneratedCookies('JSESSIONID', '', -1, '/test/');
        this.deleteServerGeneratedCookies('JSESSIONID', '', -1, '/ng/');
    }

    // Some cookies are being generated by Server. Which may restrict new user
    // to login if old cookie is retained. So, in order to make sure that new
    // cookie is generated evertytime, we will delete the old cookie saved in
    // browser.
    deleteServerGeneratedCookies(name: string, value: string, expireDays: number, path: string = '') {
        let d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires: string = `expires=${d.toUTCString()}`;
        let cpath: string = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/logout.service.ts